/**
 * Parse a pre-formatted age string from the backend (e.g. "37y",
 * "1y 4m 4d") into integer years.
 *
 * Mirrors Flutter `getAgeFromText` in `app_constants.dart:550-554` but
 * with a tighter null-safety contract: when the input is blank or
 * unparseable, Flutter returns 0 — which silently matches the HCM
 * "age ≤ 2" gate for unknown-age patients. **We return null instead**
 * so the catalog gating skips conditional rows (LMP, HCM) entirely
 * rather than rendering them by accident.
 *
 * Examples:
 *   "37y"        → 37
 *   "1y 4m 4d"   → 1
 *   "11m"        → null (no "Ny" prefix — infant, but unknown years)
 *   ""           → null
 *   undefined    → null
 */
export function parseAgeFromText(age: string | null | undefined): number | null {
  if (age == null) return null;
  const trimmed = age.trim();
  if (trimmed === '') return null;

  const idx = trimmed.indexOf('y');
  if (idx <= 0) return null;

  const prefix = trimmed.slice(0, idx);
  const n = Number.parseInt(prefix, 10);
  return Number.isFinite(n) ? n : null;
}
